module.exports = __webpack_public_path__ + "img/32@3x.68224881.png";